import { Grid, Card, Box, Dialog, Autocomplete } from '@mui/material';

import Users from 'layouts/production/Pages/All/SearchBar/components/Users';
import Tags from 'layouts/production/Pages/All/SearchBar/components/Tags';
import DateRange from 'layouts/production/Pages/All/SearchBar/components/DateRange';
import RatingComponent from 'layouts/production/Pages/All/SearchBar/components/Rating';

import { config } from 'Constants';
import { useSearch } from 'layouts/production/Pages/SearchProvider';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDInput from 'components/MDInput';

function FilterDialog(props) {
    const {
        rating,
        responsibles,
        dateRange,
        productionStatus,
        isActive,
        updateResponsibles,
        updateDateRange,
        updateProductionStatus,
        updateRating,
        updateIsActive,
    } = useSearch();

    const { open, handleClose } = props;
    const { PROJECT_STATUS_TAG_GROUP_ID } = config.fixedID;

    // Activity options for the Autocomplete component
    const activityOptions = [
        { name: 'Aktif', _id: true },
        { name: 'Pasif', _id: false },
    ];

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
            <Card>
                <MDBox p={3}>
                    <MDTypography variant="h5">Filtreler</MDTypography>
                    <Grid container spacing={3} sx={{
                        mt: 1
                    }}>
                        {gridComponent(
                            'Sorumlular',
                            <Users responsibles={responsibles} updateResponsibles={updateResponsibles} />
                        )}
                        {gridComponent(
                            'Tarih Aralığı',
                            <DateRange dateRange={dateRange} updateDateRange={updateDateRange} />
                        )}
                        {gridComponent(
                            'Üretim Durumu',
                            <Tags
                                selectedTags={productionStatus}
                                setSelectedTags={updateProductionStatus}
                                tagGroupID={PROJECT_STATUS_TAG_GROUP_ID}
                            />
                        )}
                        {gridComponent(
                            'Önem Derecesi',
                            <RatingComponent rating={rating} updateRating={updateRating} />
                        )}
                        {gridComponent(
                            'Aktivite',
                            <Autocomplete
                                options={activityOptions}
                                getOptionLabel={(option) => option.name}
                                value={activityOptions.find((option) => option._id === isActive) || null}
                                onChange={(event, newValue) => {
                                    updateIsActive(newValue?._id);
                                }}
                                renderInput={(params) => <MDInput {...params} variant="standard" />}
                            />
                        )}
                    </Grid>
                </MDBox>
            </Card>
        </Dialog>
    );
}

// A reusable component to render each grid item with a label and its children components
const gridComponent = (name, children) => {
    return (
        <Grid
            size={{
                xs: 12,
                sm: 4
            }}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <MDTypography variant="caption" fontWeight="bold" mb={1}>
                    {name}
                </MDTypography>
                {children}
            </Box>
        </Grid>
    );
};

export default FilterDialog;
